<template>
    <div>
        <div v-if="$web.isDesktop">

            <h1 class="desktop-title" v-text="loading?contents.loading:'Il tuo risultato:'"/>

            <div class="desktop desktop-card">
                <!-- Gauge -->
                <Gauge
                        :value="score?score.score:null"
                        :loading="loading"
                        class="gauge"
                        :class="!loading?'move-up':''"/>

                <!-- Loading text -->
                <p class="lead loading-text" v-if="loading">
                    Attendere prego...
                </p>

                <!-- Result -->
                <div v-else>
                    <!-- Grade -->
                    <div class="text grade" v-text="score.grade"/>

                    <!-- Subtitle-->
                    <div class="text subtitle mb-5" v-text="contents.subtitle"/>

                    <!-- Continue button -->
                    <Btn @click="nextStep" :text="contents.continue" class="desktop-btn"/>
                </div>

            </div>

        </div>
        <TopBg v-else>

            <!-- Top logo -->
            <TopLogo :white="true"/>

            <!-- Gauge -->
            <Gauge
                    :value="score?score.score:null"
                    :loading="loading"
                    class="gauge"
                    :class="!loading?'move-up':''"/>

            <!-- Loading text -->
            <div v-if="loading" class="loading-text" v-text="contents.loading"/>

            <!-- Result -->
            <div v-else>

                <!-- Grade -->
                <div class="text grade" v-text="score.grade"/>

                <!-- Subtitle-->
                <div class="text subtitle mb-5" v-text="contents.subtitle"/>

                <!-- Continue button -->
                <Btn @click="nextStep" :text="contents.continue"/>
            </div>

        </TopBg>
    </div>
</template>

<script>
    import contents from "../contents/score.json"
    import TopBg from "../components/TopBg"
    import TopLogo from "../components/TopLogo"
    import Gauge from "../components/Gauge";
    import Btn from "../components/Btn";
    import {PERIOD_MONTHLY} from "@/data/profile";

    export default {
        name: 'score',
        components: {Gauge, TopBg, TopLogo, Btn},
        mounted(){
            this.$registerEvent('Pagina', '5. Visualizzazione score');
        },
        async created() {
            let loaderPromise = new Promise(resolve => setTimeout(() => resolve(), 3000));

            let profile = Object.assign({}, this.$store.state.profile);
            profile.consumption = this.calculateYearlyValue(profile.consumption, profile.consumption_type);
            profile.cost = this.calculateYearlyValue(profile.cost, profile.cost_type);

            try {
                this.score = await this.$api.getScoreForProfile(profile);
            } catch (e) {
                this.$router.back();
                throw e;
            }

            if (!this.score){
                console.log('No score');
                return;
            }

            this.$store.commit('setProfileUUID', this.score.profile_uuid);
            await loaderPromise;
            this.loading = false;
        },
        data() {
            return {
                loading: true,
                /** @var {?ProfileScore} */
                score: null,
                contents
            };
        },
        methods: {
            calculateYearlyValue(value, period) {
                return period === PERIOD_MONTHLY ? value * 12 : value;
            },
            nextStep() {
                if (!this.$auth.isLoggedIn()) {
                    this.$login('/report');
                } else {
                    this.$router.push('/report');
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import '../styles/colors.scss';

    .gauge {
        transition: margin-top 1s;
        margin-top: 200px;

        &.move-up {
            margin-top: 120px;
        }
    }

    .desktop-card {
        max-width: 600px;
        margin: 0 auto;
    }

    .desktop-btn {
        max-width: 400px !important;
        margin: 0 auto;
        background: #f00;
    }

    .desktop .gauge {
        margin-top: 0;

        &.move-up {
            margin-top: 0;
        }
    }

    .loading-text {
        text-align: center;
        font-weight: bold;
        font-size: 22px;
        color: #555555;
    }

    .text {
        font-family: "Open Sans";
        font-weight: bold;
        text-align: center;
    }

    .grade {
        font-size: 32px;
        line-height: 44px;
        color: $darkGreen;
    }

    .subtitle {
        font-size: 18px;
        line-height: 25px;
        color: #666666;
        font-weight: 400;
    }
</style>
